import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { FormTemplate } from '../../../types/FormTemplate';

const fetchFormTemplate = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;

  const response = await CustomAxios.get<FormTemplate>(`form_templates/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetFormTemplateByIdProps {
  uuid?: string;
}

export function useGetFormTemplateById({ uuid }: UseGetFormTemplateByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allFormTemplates, uuid],
    queryFn: () => fetchFormTemplate(uuid)
  });

  return query;
}
